import DatosComunicacion from './DatosComunicacion';

export default DatosComunicacion;
